<template>
    <span v-if="info">
        <base-icon
            name="question-circle"
            prefix="far"
            type="info"
            clickable
            @click="click"
        />
        <base-modal
            v-model="show"
            :size="size"
            :close-on-click-overlay="false"
        >
            <template v-if="$slots.header" #header>
                <slot name="header" />
            </template>

            <slot :close="() => show = false">
                <span v-html="info" />
            </slot>
        </base-modal>
    </span>
</template>

<script>
export default {
    name: 'BaseInfo',
    props: {
        info: {
            type: String,
        },
        size: {
            type: [Number, String],
            default: 'medium',
        },
    },
    data() {
        return {
            show: false,
        };
    },
    methods: {
        click() {
            this.show = true;
            this.$emit('click');
        },
    },
};
</script>
